import ListingPage from "../components/ListingPage";
import { PROCEDURE_CONTENT } from "../data/procedureContent";

export default function ProceduresIndex() {
  const items = Object.entries(PROCEDURE_CONTENT).map(([slug, p]) => ({
    slug,
    shortTitle: p.shortTitle,
    blurb: p.subtitle,
  }));
  return (
    <ListingPage
      kind="Procedure"
      slug="procedures"
      eyebrow="Procedures · Varanasi"
      title="Advanced diagnostic & therapeutic procedures."
      subtitle="Done personally by Dr. Indresh Dixit — modern HD scopes, calibrated sedation and a focused recovery protocol. Each procedure page tells you exactly what to expect."
      items={items}
      seoTitle="Endoscopy, Colonoscopy, ERCP, EUS, FibroScan in Varanasi | Dr. Indresh Dixit"
      seoDescription="Advanced GI procedures in Varanasi — Upper GI Endoscopy, Colonoscopy, ERCP, EUS, FibroScan, Polypectomy and foreign-body removal — by Dr. Indresh Dixit."
    />
  );
}
